import React from "react";
import CommonBanner from "../component/Common/CommonBanner";
import EditMyTicketArea from "component/EditMyTicket";
import { useTranslation } from "react-i18next";
const EditMyTicket = () => {
    const { t } = useTranslation();
    return (
        <>
            <CommonBanner
                heading={t("flightEticket")}
                pagination="Booking submission"
            />
            <EditMyTicketArea />
        </>
    );
};

export default EditMyTicket;
